
































import Vue from "vue";
import StatsCard from "../../../components/black_dashboard_pro/Cards/StatsCard.vue";
import HttpClientFactory from "../../../services/HttpClientFactory";
import HttpClient from "../../../services/HttpClient";
import currency from "currency.js";
import InvoiceMetricsResponse from "../../../types/metrics/api/InvoiceMetricsResponse";

interface MonthSummaryType {
  amount: string | currency;
  title: string;
  type: string;
  icon: string;
  footer: string;
}

export default Vue.extend({
  components: {
    // @ts-ignore
    StatsCard,
  },
  data() {
    return {
      monthSummary: [] as MonthSummaryType[],
      httpClient: {} as HttpClient,
    };
  },
  async created() {
    this.httpClient = HttpClientFactory.getInstance();
    await this.getCurrentMonthSummary();
  },
  methods: {
    async getCurrentMonthSummary() {
      this.httpClient
        .get(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            "/metrics/v1/invoice/current-month-summary"
        )
        .then((res: any) => {
          const invoiceMetricsResponse: InvoiceMetricsResponse = res.data;

          const issuedInvoices = invoiceMetricsResponse.issued;

          if (!issuedInvoices.numInvoices || issuedInvoices.numInvoices === 0) {
            issuedInvoices.numInvoices = 0;
          }

          this.monthSummary = [
            {
              amount: currency(issuedInvoices.totalAmount, {
                fromCents: true,
                precision: 2,
              }),
              title: this.$t("metrics:amount").toUpperCase(),
              type: "success",
              icon: "tim-icons icon-coins",
              footer: this.$t("metrics:description_amount"),
            },
            {
              amount: `${issuedInvoices.numInvoices}`,
              title: this.$t("metrics:invoices").toUpperCase(),
              type: "primary",
              icon: "tim-icons icon-notes",
              footer: this.$t("metrics:description_invoice"),
            },
            {
              amount: `${issuedInvoices.numReceivers}`,
              title: this.$t("metrics:receivers").toUpperCase(),
              type: "info",
              icon: "tim-icons icon-single-02",
              footer: this.$t("metrics:description_receiver"),
            },
          ];
        })
        .catch((e: any) => {
          const error: any = {
            text: this.$t("invoices:error"),
            type: "error",
          };
          this.$notify(error);
        });
    },
  },
});
